import { Injectable, EventEmitter } from '@angular/core';
import { MsalService, BroadcastService } from '@azure/msal-angular';
import { TokenService } from '../token/token.service';
import { Account } from 'msal';
import { Router } from '@angular/router';
import { ProfessionalService } from '../professional/professional.service';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  readonly signupAuthority = "https://ia9b2c.b2clogin.com/tfp/ia9b2c.onmicrosoft.com/b2c_1_domii_register_web";
  readonly signinAuthority = "https://ia9b2c.b2clogin.com/tfp/ia9b2c.onmicrosoft.com/b2c_1_domii_signin_web";
  readonly passwordResetAuthority = "https://ia9b2c.b2clogin.com/tfp/ia9b2c.onmicrosoft.com/b2c_1_domii_reset_web"
  readonly scope = "https://IA9B2C.onmicrosoft.com/backend/user_impersonation";
  token: string = "";
  userObject: Account;
  profileInfo: any = null;
  profileUpdated: EventEmitter<any> = new EventEmitter<any>();

  constructor(private msalService: MsalService,
    private broadcastService: BroadcastService,
    private tokenService: TokenService,
    private professionalService: ProfessionalService,
    private environmentService: EnvironmentService,
    private router: Router) {
    this.msalService.handleRedirectCallback((authError, response) => {
      // check if msal error set
      if (authError) {
        // check if error code for forgot password is there
        if (authError.errorMessage.indexOf("AADB2C90118") > -1) {
          // change authority to password reset policy
          console.log(authError.errorMessage)
          this.msalService.loginRedirect({
            authority: this.passwordResetAuthority
          });
          return;
        }
      }
    });

    if (this.msalService.getAccount()) {
      this.msalService.acquireTokenSilent({
        scopes: [this.scope],
        authority: this.signinAuthority,
        account: this.msalService.getAccount()
      });
    }

    this.broadcastService.subscribe("msal:acquireTokenSuccess", payload => {
      // do something here
      console.log('tokensuccess');
      this.token = payload.accessToken;
      this.tokenService.token = payload.accessToken;
      this.userObject = this.msalService.getAccount();
      this.tokenService.userCache = this.msalService.getAccount();
      this.checkForProfileInfo();
    });

    this.broadcastService.subscribe("msal:loginFailure", payload => {
      console.log('loginfailure')
      // do something here
      if (
        payload._errorDesc &&
        payload._errorDesc.indexOf("AADB2C90118") !== -1
      ) {
        this.resetPassword();
      }
    });

    this.broadcastService.subscribe("msal:loginSuccess", payload => {
      // do something here
      console.log('loginsuccess');
      const returnUrl = sessionStorage.getItem('returnUrl');
      if (this.router.url.split('/')[1] === 'upgrade') {
        this.router.navigate(['/upgrade', this.router.url.split('/')[2].split('#')[0]]);
      } else if (this.router.url.split('/')[1] === 'prosignup') {
        this.router.navigate(['/professional/join', this.router.url.split('/')[2].split('#')[0]]);
      } else if (this.router.url.split('/')[1] === 'postcard') {
        this.router.navigate(['postcard/payment', this.router.url.split('/')[3].split('#')[0]]);
      } else if (this.router.url.split('/')[1] === 'onboard') {
        this.router.navigate(['/onboard', this.router.url.split('/')[2].split('#')[0]]);
      } else if (returnUrl === '/membership/realtors'){
        sessionStorage.setItem('returnUrl','');
        this.router.navigate([returnUrl]);
      }else {
        this.router.navigate(['dashboard']);
      }
    });
  }

  checkForProfileInfo() {
    // if there's no profile, go get it
    if (this.profileInfo == null) {
      this.professionalService.getUserProfile(this.environmentService.getIA9CoreUrl() + 'User').subscribe(
        response => {
          this.profileInfo = response;
          this.profileUpdated.emit(this.profileInfo);
        },
        error => {
          this.profileUpdated.emit(null);
        }
      );
    } else {
      // publish the fact that there is a profile info, don't just fetch it again
      this.profileUpdated.emit(this.profileInfo);
    }
  }

  login() {
    this.loginAndSignup(this.signinAuthority);
  }

  loginAndSignup(auth: string) {
    this.msalService.loginRedirect({
      scopes: [this.scope],
      authority: auth
    });
  }

  logout() {
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("X_CLIENT_ID");
    sessionStorage.removeItem("returnUrl");
    this.msalService.authority = this.signupAuthority;
    this.msalService.logout();
  }

  // Hand the reset flow to MSAL rather than building the authorize URL by hand.
  // The hand-built one sent users to https://jwt.ms — Microsoft's token debug page —
  // and carried no MSAL state, so the round trip either landed them on a raw token
  // dump or, if jwt.ms is no longer a registered reply URL for this client, on a
  // B2C error page. MSAL uses the app's own registered redirectUri and completes
  // the round trip through handleRedirectCallback like every other flow.
  resetPassword() {
    this.msalService.loginRedirect({
      scopes: [this.scope],
      authority: this.passwordResetAuthority
    });
  }
}
